import { Injectable } from '@angular/core';

@Injectable()
export class DateHelper {
  date = new Date();

  firstYear = 2019;
  currentYear = this.date.getFullYear();

  years = [...Array(this.currentYear + 1 - this.firstYear)].map((y, i) => `${this.currentYear - i}`);

  months = ['Januar', 'Februar', 'Mart', 'April', 'Maj', 'Jun', 'Jul', 'Avgust', 'Septembar', 'Oktobar', 'Novembar', 'Decembar'];

  datePickerOptions = {
    dateFormat: 'dd/mm/yyyy',
    showClearDateBtn: false,
    showTodayBtn: false,
    editableDateField: false,
    dayLabels: {su: 'Ned', mo: 'Pon', tu: 'Uto', we: 'Sre', th: 'Čet', fr: 'Pet', sa: 'Sub'},
    monthLabels: { 1: 'Jan', 2: 'Feb', 3: 'Mar', 4: 'Apr', 5: 'Maj', 6: 'Jun', 7: 'Jul', 8: 'Avg', 9: 'Sep', 10: 'Okt', 11: 'Nov', 12: 'Dec' }
  };

  calendarOptions = {
    firstDayOfWeek: 1, // Set Monday as the first day
    dayNames: ["Nedelja", "Ponedeljak", "Utorak", "Sreda", "Četvrtak", "Petak", "Subota"],
    dayNamesShort: ["Ned", "Pon", "Uto", "Sre", "Čet", "Pet", "Sub"],
    dayNamesMin: ["Ne", "Po", "Ut", "Sr", "Če", "Pe", "Su"],
    monthNames: [
      "Januar",
      "Februar",
      "Mart",
      "April",
      "Maj",
      "Jun",
      "Jul",
      "Avgust",
      "Septembar",
      "Oktobar",
      "Novembar",
      "Decembar"
    ],
    monthNamesShort: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "Maj",
      "Jun",
      "Jul",
      "Avg",
      "Sep",
      "Okt",
      "Nov",
      "Dec"
    ],
    today: "Danas",
    clear: "Poništi"
  };


  isToday(day: Date): boolean {
    day = new Date(day);
    const today = new Date();

    return day.getDate() === today.getDate() &&
      day.getMonth() === today.getMonth() &&
      day.getFullYear() === today.getFullYear();
  }

  isPastDay(day: any): boolean {
    day = new Date(day).setHours(0, 0, 0, 0);
    const today = new Date().setHours(0, 0, 0, 0);

    return today > day;
  }

  isPastDeadline(deliveryDeadline: any, today: any): boolean {
    deliveryDeadline = new Date(deliveryDeadline).setHours(0, 0, 0, 0);
    today = new Date(today).setHours(0, 0, 0, 0);

    return today > deliveryDeadline;
  }

  isDeadlineDay(deliveryDeadline: any, today: any): boolean {
    deliveryDeadline = new Date(deliveryDeadline).setHours(0, 0, 0, 0);
    today = new Date(today).setHours(0, 0, 0, 0);

    return today === deliveryDeadline;
  }

  getYesterday(): Date {
    let today = new Date();
    const yesterday = today.setDate(today.getDate() - 1);

    return new Date(yesterday);
  }

  getMonday(): Date {
    let today = new Date();
    const day = today.getDay(),
      diff = today.getDate() - day + (day == 0 ? -6 : 1); // adjust when day is sunday

    return new Date(today.setDate(diff));
  }

  dayBefore(fromDate, toDate): any {
    const fromDateFormatted = new Date(fromDate);
    fromDateFormatted.setDate(fromDateFormatted.getDate() - 1);

    const toDateFormatted = new Date(toDate);
    toDateFormatted.setDate(toDateFormatted.getDate() - 1);

    return { fromDateFormatted, toDateFormatted };
  }

  dayAfter(fromDate, toDate): any {
    const fromDateFormatted = new Date(fromDate);
    fromDateFormatted.setDate(fromDateFormatted.getDate() + 1);

    const toDateFormatted = new Date(toDate);
    toDateFormatted.setDate(toDateFormatted.getDate() + 1);

    return { fromDateFormatted, toDateFormatted };
  }

  xDaysBefore(date, numberOfDays): any {
    const toDate = new Date(date);
    toDate.setDate(toDate.getDate() - 1);

    const fromDate = new Date(date);
    fromDate.setDate(fromDate.getDate() - numberOfDays);

    return { fromDate, toDate };
  }

  xDaysAfter(date, numberOfDays): any {
    const fromDate = new Date(date);
    fromDate.setDate(fromDate.getDate() + 1);

    const toDate = new Date(date);
    toDate.setDate(toDate.getDate() + numberOfDays);

    return { fromDate, toDate };
  }

  getDayOfWeek(day: Date): number {
    const date = new Date(day);

    const dayOfWeek = {
      0: 'Ned',
      1: 'Pon',
      2: 'Uto',
      3: 'Sre',
      4: 'Čet',
      5: 'Pet',
      6: 'Sub',
    };

    return dayOfWeek[date.getDay()];
  }

  getCurrentShift(): string {
    let shift = 'I';
    const date = new Date();
    const currentHour = date.getHours();

    if (currentHour >= 8 && currentHour < 16) {
      shift = 'I';
    } else if (currentHour >= 16 && currentHour < 24) {
      shift = 'II';
    } else {
      shift = 'III';
    }

    return shift;
  }

  getCurrentYear() {
    return this.currentYear;
  }

  getCurrentMonth() {
    return this.date.getMonth();
  }

  getMonthNumber(month: string) {
    return this.months.findIndex(item => item === month);
  }

  getMonthName(index: number) {
    return this.months[index];
  }

  getDatesAndShifts(fromDate): Array<any> {

    const datesArr = [];

    fromDate.setDate(fromDate.getDate() - 1)

    for (let i = 0; i < 6; i++) {

      datesArr.push({
        date: new Date(fromDate.setDate(fromDate.getDate() + 1))
          .toISOString()
          .slice(0, 10),
        shifts: [
          {
            shiftNumber: "I"
          },
          {
            shiftNumber: "II"
          },
          {
            shiftNumber: "III"
          },
        ],
      });
    };
    return datesArr;
  }

  // Format date to i.e. 2022-12-1
  formatDateToString(date: any): any {
    if(date.date) return `${ date.date.year }-${ date.date.month }-${ date.date.day }`
    return date
  }

  // Format date to i.e. 1-12-2022
  formatDateForReports(date: any): any {
    return `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`;
  }

  // Format date to i.e. 2022-12-1
  formatDateForFilter(date: any): any {
    return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
  }

  getWeekNumber() {
    const date = new Date();
    const tempDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
    const dayNumber = (tempDate.getUTCDay() + 6) % 7;
    tempDate.setUTCDate(tempDate.getUTCDate() - dayNumber + 3);
    const firstThursday = new Date(Date.UTC(tempDate.getUTCFullYear(), 0, 4));
    const diff = Number(tempDate) - Number(firstThursday);
    const week = 1 + Math.round(diff / (7 * 24 * 60 * 60 * 1000));
    return week;
  }

  getFirstDayInMonth(month: number, year: number): Date {
    const firstDate = new Date(year, month - 1, 1);
    return new Date(firstDate.getFullYear(), firstDate.getMonth(), firstDate.getDate());
  }

  getLastDayInMonth(month: number, year: number): Date {
    const lastDate =  new Date(year, month, 0);
    return new Date(lastDate.getFullYear(), lastDate.getMonth(), lastDate.getDate());
  }

  getPreviousMonth(date: { year: number; month: number }): { year: number; month: number } {
    let { year, month } = date;

    if (month === 1) {
      month = 12;
      year -= 1;
    } else {
      month -= 1;
    }

    return { year, month };
  }

  getNextMonth(date: { year: number; month: number }): { year: number; month: number } {
    let { year, month } = date;

    if (month === 12) {
      month = 1;
      year += 1;
    } else {
      month += 1;
    }

    return { year, month };
  }

  isMonthAfterCurrentMonth(data: { year: number; month: number}): boolean {
    const currentMonth = this.getCurrentMonth() + 1;
    const currentYear = this.getCurrentYear();
    const nextMonth = currentMonth === 12 ? 1 : currentMonth + 1;
    const nextYear = currentMonth === 12 ? currentYear + 1 : currentYear;

    return data.month === nextMonth && data.year === nextYear;
  }
}
